import React from 'react';
import PropTypes from 'prop-types';
import helpMenuSvg from 'chameleon/packages/blue-book-player/library/icon-list/raw-icons/help-menu.svg';
import shortcutsSvg from 'chameleon/packages/blue-book-player/library/icon-list/raw-icons/shortcuts.svg';
import assistiveTechSvg from 'chameleon/packages/blue-book-player/library/icon-list/raw-icons/assistive-tech.svg';
import lineReaderSvg from 'chameleon/packages/blue-book-player/library/icon-list/raw-icons/line-reader.svg';
import saveExitSvg from 'chameleon/packages/blue-book-player/library/icon-list/raw-icons/save-exit.svg';
import submitSvg from 'chameleon/packages/blue-book-player/library/icon-list/raw-icons/submit.svg';
import {
  IS_HEADER_MENU_ITEM_CALCULATOR_VISIBLE,
  IS_HEADER_MENU_ITEM_SHORTCUTS_VISIBLE,
  IS_HEADER_MENU_ITEM_ASSISTIVE_TECHNOLOGY_VISIBLE,
} from 'chameleon/packages/blue-book-player/constants/componentVisibility';
import { isReferenceSheetMenuVisible } from 'chameleon/packages/blue-book-player/InnerContainer/utils';
import { HighlightsNotesHiddenSubjects } from 'chameleon/packages/blue-book-player/constants/subjects';
import MoreMenuItem from './MoreMenuItem';
import referenceSvg from '../icon-list/raw-icons/reference.svg';
import calculatorSvg from '../icon-list/raw-icons/calculator.svg';
import highlightsNotesSvg from '../icon-list/raw-icons/highlights-notes.svg';

const MoreMenuContent = (props) => {
  const {
    openExitAssignmentModal,
    openSubmitConfirmDialog,
    onLineReaderClick,
    isPreviewPlayer,
    openHelpModal,
    onReferenceSheetClick,
    onCalculatorClick,
    onAnnotationClick,
    subjectId,
  } = props;

  return (
    <>
      <div className="flex flex-col min-w-[208px]">
        {IS_HEADER_MENU_ITEM_CALCULATOR_VISIBLE && (
          <div className="bb-desktop:hidden">
            <MoreMenuItem
              itemName="Calculator"
              icon={calculatorSvg}
              onClick={onCalculatorClick}
            />
          </div>
        )}
        {isReferenceSheetMenuVisible(subjectId) && (
          <div className="bb-desktop:hidden">
            <MoreMenuItem
              itemName="Reference"
              icon={referenceSvg}
              onClick={onReferenceSheetClick}
            />
          </div>
        )}
        {!isPreviewPlayer &&
          !HighlightsNotesHiddenSubjects.includes(subjectId) && (
            <div className="bb-desktop:hidden">
              <MoreMenuItem
                itemName="Highlights & Notes"
                icon={highlightsNotesSvg}
                onClick={onAnnotationClick}
              />
            </div>
          )}
        <MoreMenuItem
          autoFocus
          itemName="Help"
          icon={helpMenuSvg}
          iconClassName="w-8"
          onClick={openHelpModal}
        />
        {IS_HEADER_MENU_ITEM_SHORTCUTS_VISIBLE && (
          <MoreMenuItem
            itemName="Shortcuts"
            icon={shortcutsSvg}
            onClick={() => {}}
          />
        )}
        {IS_HEADER_MENU_ITEM_ASSISTIVE_TECHNOLOGY_VISIBLE && (
          <MoreMenuItem
            itemName="Assistive Technology"
            icon={assistiveTechSvg}
            onClick={() => {}}
          />
        )}
        <MoreMenuItem
          itemName="Line Reader"
          icon={lineReaderSvg}
          iconClassName="w-8"
          onClick={onLineReaderClick}
        />
        {isPreviewPlayer ? null : (
          <MoreMenuItem
            itemName="Save and Exit"
            icon={saveExitSvg}
            onClick={openExitAssignmentModal}
            data-test-id="save-exit-more-menu-item"
            data-cy="save-exit-more-menu-item"
          />
        )}
        {isPreviewPlayer ? null : (
          <MoreMenuItem
            itemName="Submit"
            icon={submitSvg}
            onClick={openSubmitConfirmDialog}
            data-test-id="submit-more-menu-item"
            data-cy="submit-more-menu-item"
          />
        )}
      </div>
    </>
  );
};

MoreMenuContent.propTypes = {
  openExitAssignmentModal: PropTypes.func,
  onLineReaderClick: PropTypes.func,
};

MoreMenuContent.defaultProps = {
  openExitAssignmentModal: () => {},
  onLineReaderClick: () => {},
};

export default MoreMenuContent;
